"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionLabel = exports.Select = void 0;
var React = __importStar(require("react"));
var styles = __importStar(require("./styles.modules.css"));
var icon_1 = require("../icon");
var removeable_option_1 = require("./removeable-option");
var bind_1 = __importDefault(require("classnames/bind"));
var lib_1 = require("@ribit/lib");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    options: [],
    noResultsText: "No options...",
    autoPlaceholder: true,
};
var optionLabel = function (option) {
    if (!option) {
        return null;
    }
    var label = option.label ? option.label : option.value;
    return label;
};
exports.optionLabel = optionLabel;
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        var _this = _super.call(this, props) || this;
        _this.interactionCheck = function (e) {
            if (_this.selectorRef.current &&
                !_this.selectorRef.current.contains(e.target) &&
                _this.state.opened) {
                _this._closeDropdown();
            }
        };
        _this._renderedOptionLabel = function (option) {
            var optionRenderer = _this.props.optionRenderer;
            var label;
            if (optionRenderer) {
                label = optionRenderer(option);
            }
            else {
                label = optionLabel(option);
            }
            return label;
        };
        _this._executeAsyncRequest = function (value, opened) {
            if (value === void 0) { value = null; }
            if (opened === void 0) { opened = true; }
            var _a = _this.state, optionCache = _a.optionCache, loading = _a.loading;
            if (loading) {
                return;
            }
            _this.setState({
                loading: true,
            });
            var async = _this.props.async;
            async.callback(value).then(function (foundOptions) {
                var cachedOptions = foundOptions.filter(function (option) {
                    return !optionCache.filter(function (_existingOption) {
                        return (0, lib_1.isEqual)(_existingOption.value, option.value);
                    }).length;
                });
                cachedOptions = cachedOptions.concat(optionCache);
                _this.setState(function () { return ({
                    optionCache: cachedOptions,
                    options: foundOptions,
                    loading: false,
                    opened: opened,
                }); });
            });
        };
        _this._handleAsyncRequest = function (event) {
            var async = _this.props.async;
            var threshold = async.threshold;
            var value = event.target.value;
            if (threshold && value.length < threshold) {
                return;
            }
            clearTimeout(_this.keyUpTimeout);
            _this.keyUpTimeout = setTimeout(function () {
                _this._executeAsyncRequest(value);
            }, 500);
        };
        _this._startTyping = function () {
            var async = _this.props.async;
            if (!_this.state.opened && async && !async.preventCallOnOpen) {
                _this._executeAsyncRequest();
            }
            _this.setState({ typing: true });
        };
        _this._stopTyping = function () {
            setTimeout(function () {
                _this.setState({ typing: false, opened: false });
            }, 150);
        };
        _this._changeDropdownHover = function (event) {
            var options = _this.state.options;
            var hovered = _this.state.hovered;
            var down = event.key === "ArrowDown";
            var up = event.key === "ArrowUp";
            if (event.key === "Enter" && hovered > -1) {
                _this._onSelectOption(options[hovered], false);
                event.target["value"] = "";
            }
            else if (down || up) {
                event.preventDefault();
                var total = options.length;
                if (hovered === null) {
                    if (down) {
                        hovered = -1;
                    }
                    else {
                        hovered = total;
                    }
                }
                if (down) {
                    hovered++;
                }
                else {
                    hovered--;
                }
                if (hovered >= total) {
                    hovered = 0;
                }
                else if (hovered < 0) {
                    hovered = total - 1;
                }
                _this.setState({ hovered: hovered });
            }
        };
        _this._changeDropdownMouseHover = function (option) {
            var options = _this.state.options;
            _this.setState({ hovered: options.indexOf(option) });
        };
        _this._renderValue = function (selectedOptions) {
            var _a = _this.props, multiple = _a.multiple, async = _a.async, autoPlaceholder = _a.autoPlaceholder, name = _a.name;
            var typing = _this.state.typing;
            var controlLabel = null;
            var className = styles.label;
            var placeholder = _this.props.placeholder;
            if (autoPlaceholder && !placeholder) {
                placeholder = "Select a ".concat(name, "...");
                if (async) {
                    placeholder = "Type to find a ".concat(name, "...");
                }
            }
            if (!selectedOptions || (selectedOptions && !selectedOptions.length)) {
                controlLabel = placeholder;
                className = styles.placeholder;
            }
            else {
                if (multiple) {
                    controlLabel = placeholder;
                    className = styles.placeholder;
                }
                else {
                    controlLabel = (React.createElement("div", { className: styles.inputValue, onMouseUp: _this._toggleDropdown }, optionLabel(selectedOptions[0])));
                }
            }
            if (async) {
                controlLabel = (React.createElement(React.Fragment, null,
                    !typing ? (React.createElement("div", { className: styles.inputValue, tabIndex: 0, onMouseUp: _this._startTyping, onFocus: _this._startTyping, onKeyDown: _this._toggleDropdown }, controlLabel)) : null,
                    typing ? (React.createElement(React.Fragment, null,
                        React.createElement("input", { type: "text", placeholder: placeholder, className: styles.input, autoFocus: true, onChange: _this._handleAsyncRequest, onBlur: _this._stopTyping, onKeyDown: _this._changeDropdownHover }))) : null));
            }
            return React.createElement("div", { className: className }, controlLabel);
        };
        _this._closeDropdown = function () {
            setTimeout(function () {
                _this.setState(function () { return ({
                    opened: false,
                    hovered: null,
                    typing: false,
                }); });
            }, 10);
        };
        _this._toggleDropdown = function () {
            var async = _this.props.async;
            if (!_this.state.opened && async && !async.preventCallOnOpen) {
                _this._executeAsyncRequest();
            }
            _this.setState({
                opened: !_this.state.opened,
                hovered: null,
                typing: false,
            });
        };
        _this._renderToggle = function () {
            var async = _this.props.async;
            var focusable = null;
            if (!async) {
                focusable = {
                    tabIndex: 0,
                    onKeyUp: function (event) {
                        if (event.key === "Enter") {
                            _this._toggleDropdown();
                        }
                    },
                };
            }
            var icon = _this.state.opened ? icon_1.Icons.ChevronUp : icon_1.Icons.ChevronDown;
            return (React.createElement("a", __assign({}, focusable, { onMouseUp: _this._toggleDropdown, className: styles.toggle }),
                React.createElement(icon_1.Icon, { icon: icon })));
        };
        _this._onSelectOption = function (option, shouldToggle) {
            if (shouldToggle === void 0) { shouldToggle = true; }
            var _a = _this.props, name = _a.name, onChange = _a.onChange, multiple = _a.multiple;
            if (onChange && option) {
                onChange(name, option.value, multiple);
            }
            if (shouldToggle) {
                _this._toggleDropdown();
            }
        };
        _this._renderSelectedOptions = function (options) {
            var multiple = _this.props.multiple;
            if (!multiple || !options.length) {
                return null;
            }
            return (React.createElement("div", { className: styles.selectedOptions }, options.map(function (option, index) {
                return (React.createElement(removeable_option_1.RemoveableOption, { key: index, option: option, onRemove: function (option) { return _this._onSelectOption(option, false); } }));
            })));
        };
        _this.mainContent = function (selectOptions, selectedOptions, dropdownLabel, hovered, classNames, style) {
            return (React.createElement("div", { className: styles.select },
                _this._renderSelectedOptions(selectedOptions),
                React.createElement("div", { className: classNames, style: style },
                    React.createElement("div", { className: styles.control },
                        _this._renderValue(selectedOptions),
                        _this._renderToggle()),
                    React.createElement("div", { className: styles.dropdown },
                        selectOptions.map(function (option, index) {
                            var optionClassName = cx({
                                option: true,
                                hovered: hovered === index,
                            });
                            return (React.createElement("div", { className: optionClassName, title: optionLabel(option), key: index, onMouseOver: function () {
                                    _this._changeDropdownMouseHover(option);
                                }, onMouseUp: function () {
                                    _this._onSelectOption(option);
                                } }, _this._renderedOptionLabel(option)));
                        }),
                        !selectOptions.length ? (React.createElement("div", { className: styles.noResults }, dropdownLabel)) : null))));
        };
        _this.state = {
            opened: false,
            typing: false,
            loading: false,
            optionCache: props.options,
            options: props.options,
            hovered: null,
        };
        _this.selectorRef = React.createRef();
        return _this;
    }
    Object.defineProperty(Select.prototype, "value", {
        get: function () {
            var value = this.props.value;
            return value;
        },
        enumerable: false,
        configurable: true
    });
    Select.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.options !== prevState.options && !nextProps.async) {
            return { options: nextProps.options };
        }
        else if (nextProps.options.length > prevState.optionCache.length) {
            return { optionCache: nextProps.options, options: nextProps.options };
        }
        else {
            return null;
        }
    };
    Select.prototype.componentDidMount = function () {
        if (this.props.loadImmediate && this.props.async) {
            this._executeAsyncRequest(null, false);
        }
        window.addEventListener("mouseup", this.interactionCheck);
    };
    Select.prototype.componentWillUnmount = function () {
        window.removeEventListener("mouseup", this.interactionCheck);
    };
    Select.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, width = _b.width, hideSelected = _b.hideSelected, className = _b.className, noResultsText = _b.noResultsText, async = _b.async;
        var _c = this.state, options = _c.options, hovered = _c.hovered, loading = _c.loading, optionCache = _c.optionCache;
        var dropdownLabel = noResultsText;
        if (async) {
            var loadingText = async.loadingText;
            if (loadingText && loading) {
                dropdownLabel = loadingText;
            }
        }
        var style = {};
        if (width) {
            style.width = "".concat(width, "%");
        }
        var currentValue = this.value !== undefined
            ? Array.isArray(this.value)
                ? this.value
                : [this.value]
            : [];
        var selectedOptions = currentValue.reduce(function (previous, current) {
            previous.push(optionCache.filter(function (option) { return (0, lib_1.isEqual)(option.value, current); })[0]);
            return previous;
        }, []);
        var classNames = cx((_a = {
                outer: true,
                opened: this.state.opened
            },
            _a[className] = className,
            _a));
        var selectOptions = options.reduce(function (previous, current) {
            if (hideSelected && current.value === _this.value) {
                return previous;
            }
            previous.push(current);
            return previous;
        }, []);
        return (React.createElement("div", { ref: this.selectorRef }, this.mainContent(selectOptions, selectedOptions, dropdownLabel, hovered, classNames, style)));
    };
    Select.defaultProps = defaultProps;
    return Select;
}(React.Component));
exports.Select = Select;
//# sourceMappingURL=select.js.map